// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__TeJmp","icon":"style_icon__1n5Jp"};